import React from 'react'
import { breakpoints } from 'src/ui/dimensions'

import { styled } from 'src/ui/theme'
import { HBox, Wrapper } from 'src/ui/layout'
import { Image } from 'src/ui/atoms'
import { HeroDesktopSecondary } from 'src/ui/organisms'

import { Body, Header } from 'src/ui/typography'
import { EVENTS, SPACE, SPORT, TRADITION } from './constants'

const Row = styled.div`
  display: grid;
  grid-template-columns: 43.9% 52.3%;
  gap: 3.8%;
`

const Row3 = styled.div`
  display: grid;

  grid-template-columns: 43.9% 52.3%;
  gap: 3.8%;
`

const Col = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
`

const Title = styled.div`
  display: grid;
  grid-template-columns: 50% 46%;
  gap: 4%;

  @media (max-width: ${breakpoints.tablet}px) {
    grid-template-columns: 1fr;
  }
`

const VideoBlock = styled.div`
  position: relative;
`

const VideoBlockTitle = styled.div<{ top: number }>`
  position: absolute;
  top: ${({ top }) => top}px;
  right: 0;
  width: 368px;
  padding: 64px 40px;
  background: ${({ theme }) => theme.colors.white.primary};
  transition: top 0.3s;
`

const Digit = styled.span`
  font-size: 48px;
`
const Heading = styled.div`
  position: relative;
  min-height: 58px;
  ${Digit} {
    position: absolute;
    left: 0;
    top: 0;
  }
`

type Props = {
  images: TImages
}

export const Office: React.FC<Props> = ({ images }) => {
  return (
    <>
      <HBox height={74} />
      <Wrapper>
        <Title>
          <Col>
            <Header size="h2" as="h2">
              Офис в Калининграде
            </Header>
          </Col>

          <Col>
            <HBox height={8} />
          </Col>
        </Title>
        <HBox height={64} />
        <Row>
          <Col>
            <Heading>
              <Header size="h4" as="h2">
                Пространство для продуктивной работы
              </Header>
            </Heading>
            <HBox />
            <Body>{SPACE}</Body>
            <HBox height={24} />
          </Col>

          <Col>
            <Image height={350} fluid={images['office-space']} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Image
              height={350}
              fluid={images['tradition']}
              objectPosition="bottom center"
            />
          </Col>
          <Col>
            <HBox height={40} />
            <Heading>
              <Header size="h4" as="h2">
                Вкусные традиции
              </Header>
            </Heading>
            <HBox />
            <Body>{TRADITION}</Body>
            <HBox height={24} />
          </Col>
        </Row>

        <Row3>
          <Col>
            <HBox height={40} />
            <Heading>
              <Header size="h4" as="h2">
                Спорт и активный образ жизни
              </Header>
            </Heading>
            <HBox />
            <Body>{SPORT}</Body>
            <HBox height={24} />
          </Col>

          <Col>
            <Image height={350} fluid={images['sport']} />
          </Col>
        </Row3>

        <Row>
          <Col>
            <Image height={350} fluid={images['events']} />
          </Col>
          <Col>
            <HBox height={54} />
            <Heading>
              <Header size="h4" as="h2">
                Мероприятия для кодеров
              </Header>
            </Heading>
            <HBox />
            <Body>{EVENTS}</Body>
            <HBox height={40} />
          </Col>
        </Row>
      </Wrapper>
      <HBox height={130} />
    </>
  )
}
